import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { BedDouble, Bath, Car, Maximize } from 'lucide-react';
const smoothEase = [0.22, 1, 0.36, 1];
const containerVariants = {
  hidden: {},
  visible: {
    transition: {
      staggerChildren: 0.12,
      delayChildren: 0.1
    }
  }
};
const itemVariants = {
  hidden: {
    opacity: 0,
    y: 16
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.7,
      ease: smoothEase
    }
  }
};
export function PropertyDetails() {
  const stats = [{
    icon: BedDouble,
    value: '5',
    label: 'Bedrooms'
  }, {
    icon: Bath,
    value: '3',
    label: 'Bathrooms'
  }, {
    icon: Car,
    value: '2',
    label: 'Car Spaces'
  }, {
    icon: Maximize,
    value: '697',
    label: 'm² (approx.)'
  }];
  return <section className="w-full py-20 md:py-28" data-id="element-95">
      <div className="max-w-5xl mx-auto px-6 md:px-12" data-id="element-96">
        <motion.div variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: '-80px'
      }} className="grid grid-cols-2 md:grid-cols-4 gap-10 md:gap-0" data-id="element-97">
          {stats.map((stat, index) => <motion.div key={stat.label} variants={itemVariants} className={`flex flex-col items-center justify-center text-center ${index !== stats.length - 1 ? 'md:border-r border-luxury-divider' : ''}`} data-id="element-98">
              <stat.icon className="w-5 h-5 text-luxury-gold mb-5" strokeWidth={1.25} data-id="element-99" />

              <span className="font-playfair text-2xl md:text-3xl text-luxury-cream mb-1" data-id="element-100">
                {stat.value}
              </span>
              <span className="text-luxury-taupe text-[11px] md:text-xs tracking-[0.2em] uppercase" data-id="element-101">
                {stat.label}
              </span>
            </motion.div>)}
        </motion.div>
      </div>
    </section>;
}